import React from 'react';

import { RequestApiMethod } from 'app/types-shared';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { manageOptionsButton } from 'app/area/shared/manage-options';

import { LinkCodesTranslation } from '../constants';
import { endpoints } from '../endpoints';
import { useBreadcrumbsSelectors, useDetailsCallbacks, useDetailsSelectors, useMetadataSelectors } from '../hooks';
import { CodeFieldWireKey } from '../types';
import { getEndpointOptions, getLabel } from '../utils/selected-value';
import { LinkCodesDetailsPicker } from './link-codes-details-picker';
import { ValidationLevel, ValidationMessage } from 'ui';

const codetableId = 'codetable';
const categoryId = 'category';
const activeValueId = 'activeValue';

interface LinkCodesDetailsProps {
  shouldPrompt: boolean;
  activeValueError: ValidationMessage;
  translation: LinkCodesTranslation;
}

export const LinkCodesDetails: React.FC<LinkCodesDetailsProps> = ({
  shouldPrompt, activeValueError, translation
}) => {

  const { metadata } = useMetadataSelectors();
  const { fetchingBreadcrumbs, nodeCodetable } = useBreadcrumbsSelectors();
  const { codetableValue, categoryValue, activeValue, activeType } = useDetailsSelectors();
  const { updateCodetable, updateCategory, updateActiveValue } = useDetailsCallbacks();

  if (fetchingBreadcrumbs) {
    return null;
  }

  return <div className="row">
    {!isDefinedIncludingZero(nodeCodetable) && <LinkCodesDetailsPicker
      componentId={codetableId}
      label={translation.codetable}
      endpoint={endpoints.codetableOptions}
      shouldPrompt={shouldPrompt}
      valueItem={codetableValue}
      onChange={updateCodetable}
      optionsParams={{ excludeCodetablesWithoutSubset: true }}
      translation={translation} />}
    {isDefinedIncludingZero(metadata?.category?.id) &&
      <LinkCodesDetailsPicker
        componentId={categoryId}
        label={metadata.category.label}
        codetableId={metadata?.category?.id}
        endpoint={endpoints.codetableSearch(metadata.category.id)}
        shouldPrompt={shouldPrompt}
        valueItem={categoryValue}
        onChange={updateCategory}
        loadOptionsParams={{ requestApiMethod: RequestApiMethod.post, displayNotSelected: false, apiVersion: '3.0' }}
        optionsParams={{ limitFieldsTo: [CodeFieldWireKey.code] }}
        optionsRequestPayload={{ includeInactiveCodes: { enabled: false } }}
        searchRequired={metadata.category.searchRequired}
        extraFooterButton={manageOptionsButton(translation.manage_options, metadata.category.id)}
        translation={translation} />}
    <div className="row">
      <LinkCodesDetailsPicker
        componentId={activeValueId}
        label={getLabel(activeType, translation)}
        shouldPrompt={shouldPrompt}
        valueItem={activeValue}
        onChange={updateActiveValue}
        translation={translation}
        validation={activeValueError
          && { level: ValidationLevel.error, messages: [activeValueError] }}
        {...getEndpointOptions(activeType, metadata?.type, translation)} />
    </div>
  </div>;
};
